import homepage from './views/Homepage';
import videoHomepage from './views/VideoHomepage';
import editorialView from './views/Editorial';
import infoView from './views/Info';
import productView from './views/Product';
import indexView from './views/Index';
import peopleView from './views/People';
import shopIndexView from './views/ShopIndex';
import shopStoryView from './views/ShopStory';
import aboutView from './views/About';
import error404View from './views/error404';

export default [
	homepage,
	videoHomepage,
	editorialView,
	infoView,
	productView,
	indexView,
	peopleView,
	shopIndexView,
	shopStoryView,
	aboutView,
	error404View,
];
